import React from "react";
import { Link } from "@sscs/ui";
import { HelpIcon } from "@sscs/ui/icons";
import styles from "./localConfiguration.module.scss";

const LocalConfigurationPanel = (): React.JSX.Element => {
  return (
    <div className={styles["local-config"]}>
      <span>
        You are currently using local login. Users will log in with their
        username and password. In this case, roles and groups are assigned from
        the Members tab.
      </span>
      <span>
        To switch to an SSO protocol, select one of the options above.
      </span>
      <span>
        If you don’t currently have any SSO configuration details saved, make
        sure to first set up an application interface in your SSO identity
        provider.
      </span>
      <small className={styles["info-flex"]}>
        <HelpIcon />
        <span>
          If you need more help,{" "}
          <Link
            href="https://docs.secure.software/portal/sso-configuration"
            target="_blank"
            rel="noreferrer"
            inline
            underline="hover"
          >
            click here
          </Link>
        </span>
      </small>
    </div>
  );
};

export default LocalConfigurationPanel;
